import paymentRoutes from "./paymentRoutes";
import publicRoutes from "./publicRoutes";
import privateRoutes from "./privateRoutes";

export const appRouteConfig = [
  ...paymentRoutes,
  publicRoutes,
  {
    type: "route",
    id: "patient-registration-form",
    name: "Patient Registration Form",
    path: "/patient-registration-form/:id",
    component: "PatientRegistrationForm",
  },
 {
    type: "route",
    id: "field-staff-assignment-response",
    name: "Field Staff Assignment Response",
    path: "/field-staff/assignment-response",
    component: "FieldStaffAssignmentResponse",
  },
  {
    type: "route",
    id: "field-staff-attendance",
    name: "Field Staff Attendance",
    path: "/field-staff/attendance",
    component: "FieldStaffAttendance",
  },
  {
    type: "route",
    id: "staffing-nomination",
    name: "Staffing Nomination",
    path: "/staffing-nomination",
    component: "NominationForm",
  },
  {
    type: "route",
    id: "pre-deployment-checklist",
    name: "Pre-Deployment Checklist",
    path: "/pre-deployment-checklist/:programId",
    component: "PreDeploymentChecklistPage",
  },
  {
    type: "route",
    id: "post-deployment-checklist",
    name: "Post-Deployment Checklist",
    path: "/post-deployment-checklist/:programId",
    component: "PostDeploymentChecklistPage",
  },
  {
    type: "route",
    id: "inventory-usage-token",
    name: "Inventory Usage",
    path: "/inventory-usage",
    component: "InventoryUsagePage",
  },
  {
    type: "route",
    id: "supervisor-deployment-checklist",
    name: "Supervisor Deployment Checklist",
    path: "/supervisor-deployment-checklist/:programId",
    component: "SupervisorDeploymentChecklistPage",
  },
  {
    type: "route",
    id: "inventory-usage",
    name: "Inventory Usage",
    path: "/inventory-usage/:programId",
    component: "InventoryUsagePage",
  },
  privateRoutes,
  {
    type: "route",
    id: "logout",
    name: "Logout",
    path: "/logout",
    component: "Logout",
  },
];

export { paymentRoutes, publicRoutes, privateRoutes };
